import { render, staticRenderFns } from "./DeleteTemplateModule.vue?vue&type=template&id=256dcde4&scoped=true"
import script from "./DeleteTemplateModule.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256dcde4",
  null
  
)

export default component.exports